import { ADDTOCART, REMOVEFROMCART } from "./actionTypes";

const initialState = {
    cartItems: [
        {
            quantity: 0,
            productId: 1
        },
        {
            quantity: 0,
            productId: 2
        },
        {
            quantity: 0,
            productId: 3
        }
    ] 
};

export const cartReducer = (state = initialState, action) => {
    switch(action.type) {
        case ADDTOCART: {
            return {
                ...state,
                cartItems: state.cartItems.map(cartItem => {
                    if(cartItem.productId === action.payload) {
                        cartItem.quantity = cartItem.quantity + 1;
                    }
                    return cartItem;
                })
            };
        }
        case REMOVEFROMCART: {
            return {
                ...state,
                cartItems: state.cartItems.map(cartItem => {
                    if(cartItem.productId === action.payload) {
                        cartItem.quantity = cartItem.quantity - 1;
                    }
                    return cartItem;
                })
            };
        };
        default: {
            return state;
        }
    }
};